import React, { useContext, useState, useCallback } from 'react'
import styled from 'styled-components'
import { I18nContext } from 'i18n'
import { Container, Row, Col } from 'react-bootstrap'
import { navigate } from 'raviger'
import { checkPermission } from 'utils/permission'
import classnames from 'classnames'
import { useAlert } from 'react-alert'
import {
  DownloadScholarshipsModal,
  PreUploadModal,
  Permission,
  HomeCard,
  CustomLinks,
} from 'components'
import { device } from 'utils/device'

const Home = ({ stagedCount, getStagedCount }) => {
  const [showDownload, setShowDownload] = useState(false)
  const [showUpload, setShowUpload] = useState(false)
  const { translate } = useContext(I18nContext)
  const alert = useAlert()

  const sections = [
    {
      section: 'programs',
      src: '/data-center/programs',
      permissions: ['scholarships'],
    },
    {
      section: 'download',
      permissions: ['canExportScholarships'],
    },
    {
      section: 'upload',
      permissions: ['canImportScholarships'],
    },
    {
      section: 'program-updates',
      permissions: ['scholarships'],
      badge: stagedCount && `${stagedCount} pending`,
      src: '/data-center/program-updates',
    },
    {
      section: 'help',
      permissions: ['scholarships'],
      src: '/data-center/help-info',
    },
    {
      section: 'organization',
      permissions: ['scholarships'],
      clickable: false,
      description: (
        <CustomLinks
          location="SUPPORTED_SPONSORS"
          options={{ renderers: { paragraph: 'div' } }}
        />
      ),
    },
  ]

  const handleClick = useCallback(
    (src, permissions, section) => {
      if (!permissions) {
        alert.info('Feature to Come, Not Yet Implemented')
        return
      }
      if (checkPermission(permissions)) {
        if (src) navigate(src)

        if (section === 'download') {
          //Show download modal
          setShowDownload(true)
        } else if (section === 'upload') {
          setShowUpload(true)
        }
      } else {
        alert.info(
          'You do not have permission to View & Edit. Please contact your administrator'
        )
      }
    },
    [setShowDownload, setShowUpload]
  )

  return (
    <ContainerHome>
      <Container>
        <Row>
          {sections.map(
            ({
              src,
              permissions,
              section,
              badge,
              icon,
              clickable = true,
              description,
            }) => (
              <Permission permission={permissions} key={`home-${section}`}>
                <Col md={12} lg={6} xl={4}>
                  <HomeCard
                    onClick={() => handleClick(src, permissions, section)}
                    icon={icon || require(`images/${section}.png`)}
                    title={translate(`data_center_${section}_title`)}
                    description={
                      description ||
                      translate(`data_center_${section}_description`)
                    }
                    badge={badge}
                    className={classnames({ clickable })}
                  />
                </Col>
              </Permission>
            )
          )}
        </Row>
      </Container>
      {showDownload && (
        <DownloadScholarshipsModal show onHide={() => setShowDownload(false)} />
      )}

      <PreUploadModal
        show={showUpload}
        setShow={setShowUpload}
        onHide={() => setShowUpload(false)}
        getStagedCount={getStagedCount}
      />
    </ContainerHome>
  )
}

const ContainerHome = styled.div`
  width: 70%;
  margin: 0 auto;
  min-height: 30rem;

  a {
    color: ${({ theme }) => theme.palette.primary[3]};
  }

  @media ${device.mobileL} {
    width: 80%;
    padding: 0;
    margin-top: 0;
  }
`

export default Home
